import { LoginAttempt } from '../builders/login_attempt_builder';
import { Datasource, IDatasource, IDatasourceConstructor } from 'utility-ng-kernel';

export interface ILoginAttemptsDatasource extends IDatasource<LoginAttempt> {
  put: (o: Partial<LoginAttempt>) => LoginAttempt;
}

angular
  .module('capability-ng-user-app')
  .service('ngLoginAttemptsDatasource', function(
    ngLoginAttemptBuilder: typeof LoginAttempt,
    Datasource: IDatasourceConstructor<LoginAttempt>
  ) {
    const ngLoginAttemptsDatasource: ILoginAttemptsDatasource = new Datasource({
      builderType: ngLoginAttemptBuilder
    });

    ngLoginAttemptsDatasource.$prePut = (v) => {
      const loginAttempt = ngLoginAttemptsDatasource.get(v.id);
      if (!_.isUndefined(loginAttempt)) {
        loginAttempt!.attempts++;
        return loginAttempt!;
      }
      return v;
    };

    return ngLoginAttemptsDatasource;
  });



// WEBPACK FOOTER //
// ./app/lib/user_app/datasources/login_attempts_datasource.ts